import { cn } from "@/lib/utils";
import useTermsCondition from "./useTermsCondition";

const TermsCondition = () => {
  const { terms } = useTermsCondition();
  return (
    <div className="p-4 text-[18px] bg-white max-w-screen px-auto lg:px-100 flex flex-col items-center justify-center min-h-screen font-[arial]">
      <h1 className="font-[600] text-2xl text-center mt-10 mb-15">
        COMMUNACAM SOFTWARE – TERMS & CONDITIONS (END USER)
      </h1>

      <div>
        <ul className="flex flex-col gap-3">
          <li>
            <b>Version: V1</b>
          </li>
          <li>
            <b>Effective Date:</b> December 8, 2025
          </li>
          <li>
            <b>Last Updated:</b> December 8, 2025
          </li>
          <li>
            <b>Software Owner / Licensor:</b> GGCL Corporation LLC (“GGCL”)
          </li>
          <li>
            <b>Platform:</b> “CommunaCam” (the “Software”)
          </li>
          <li>
            <b>Association(s):</b> Radcliff Ridge Homeowners Association and any
            other association(s) using the Software (“Association, ”
            “Associations”)
          </li>
          <li>
            <b>Management Company (if applicable):</b> CommunaCam LLC
            (“Management Company”)
          </li>
        </ul>
        <div className="my-10">
          <i>
            Important: This is a terms-of-use agreement for end users (Owners,
            Directors, Tenants, Authorized Agents, etc.). It is separate from
            any management services agreement between an Association and a
            management company.
          </i>
        </div>
      </div>

      <div className="flex flex-col gap-15">
        {terms?.map((val: any, index: number) => {
          return (
            <div key={`term-${index + 2}`}>
              <p className="text-primary text-xl font-[600] mb-3">
                {index + 1}) {val.title}
              </p>
              {val.subTitle ? <span>{val.subTitle}</span> : <></>}
              <ul
                className={cn(
                  "space-y-3 mt-2",
                  val.showBullet ? "list-disc pl-5" : ""
                )}
              >
                {val?.subPoints?.map((point: any, idx: number) => (
                  <li key={`point-${index + 2}-${idx}`}>
                    {val.showBullet ? (
                      <></>
                    ) : (
                      <b className="mr-3">
                        {index + 1}.{idx + 1}
                      </b>
                    )}
                    {point.title}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TermsCondition;
